import { navigate as routerNavigate } from '@arr2019/router-navigate';
import { trackHistory } from '@local/router-track-history';

export function navigate(props) {
  trackHistory();
  return routerNavigate(props);
}
